import { Box, Typography } from '@material-ui/core';
import { accessHistoryApi } from 'api/authApi';
import { postOnlineReservationsNewCustomer } from 'api/onlineBookingV2Api';
import verifyingTheUserResponseByTokenApi from 'api/recaptchaApi';
import ScreenLoader from 'components/organismos/ScreenLoader';
import useAppSnackbar from 'hooks/useAppSnackbar';
import BigButtonNext from 'pages/reservationBookingOnlineV2/components/BigButtonNext';
import TableDetail from 'pages/reservationBookingOnlineV2/components/TableDetail';
import { StatusBooking, useReservationBookingOnlineContext } from 'pages/reservationBookingOnlineV2/context';
import { formatDataInfoCustomerToSubmit, getDesiredYear, returnHistoryPath } from 'pages/reservationBookingOnlineV2/functions';
import { stringify } from 'qs';
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import handleError from 'utility/handleError';
import SectionHeader from '../../components/SectionHeader';
import useStyles from './styles';

interface IStepConfirmationOfReservationDetail {
  companyCode:string,
  courseCode?:string,
  mediaCode?:string,
  gender?:string,
  serviceCode?:string,
  trackingCode?:string,
}
declare global {
  interface Window { grecaptcha: any; }
}

const StepConfirmationOfReservationDetail : React.FC<IStepConfirmationOfReservationDetail> = ({
  companyCode, courseCode, mediaCode, gender, serviceCode, trackingCode,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { enqueueSnackbar } = useAppSnackbar();
  const [isLoading, setLoading] = useState(false);
  const timeOutRef = useRef<any>(null);
  const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;
  const GOOGLE_RECAPTCHA_V3_SCRIPT = 'https://www.google.com/recaptcha/api.js';
  const SCRIPT_ID = 'google-recaptcha-v3';
  const GOOGLE_RECAPTCHA_BADGE_CLASSNAME = '.grecaptcha-badge';
  const LANGUAGE = 'ja';
  const { ...context } = useReservationBookingOnlineContext();
  const {
    chosenDesiredServiceName, chosenDesiredCareName, chosenCourseName, chosenAreaName, chosenStoreName, chosenStore, desiredTime,
    customerFirstName, customerLastName, customerFirstNameNameInFurigawa, customerLastNameNameInFurigawa,
    customerBirthdayYear, customerBirthdayMonth, customerBirthdayDay, phoneNumber1, phoneNumber2, phoneNumber3,
    emailAddress, consultationOrRequest, isEmailNewsLetter, desiredMonth2, desiredDay2, desiredHour2, desiredMonth3, desiredDay3, desiredHour3, status, chosenCourseAcceptRequestReservation, handleChangeInfoBooking,
  } = context;

  const InfoSearchBooking = [
    { title: '性別', content: chosenDesiredServiceName || '' }, // Service
    { title: 'ご希望のサービス', content: chosenDesiredCareName || '' }, // Care
    { title: 'ご希望のコース', content: chosenCourseName || '' }, // Course
    { title: 'ご希望のエリア', content: chosenAreaName || '' }, // Area
    { title: 'ご希望の店舗', content: chosenStoreName || '' }, // Store
  ];

  const InfoDateBooking = [
    { title: `${status === StatusBooking.AVAILABLE_BOOKING ? 'ご来店日時' : '第一希望'}`, content: desiredTime || '' }, // Desired Time
  ];

  const InfoCustomerBooking = [
    { title: 'お名前', content: `${customerLastName || ''}${customerFirstName || ''}` }, // Full name
    { title: 'ふりがな', content: `${customerLastNameNameInFurigawa || ''}${customerFirstNameNameInFurigawa || ''}` }, // Furigana
    { title: '生年月日', content: `${customerBirthdayYear}年${customerBirthdayMonth}月${customerBirthdayDay}日` }, // Date of birth
    { title: 'メールアドレス', content: emailAddress || '' }, // Email address
    { title: 'お電話番号', content: `${phoneNumber1}${phoneNumber2}${phoneNumber3}` }, // Phone
    { title: 'ご相談・ご要望', content: consultationOrRequest || '' }, // Consultation/request
    { title: 'メルマガを希望する', content: isEmailNewsLetter === 'true' ? 'はい' : 'いいえ' }, // Mail magazine hope
  ];

  if (desiredMonth3 && desiredDay3) {
    InfoCustomerBooking.splice(4, 0, { title: '第三希望', content: (desiredMonth3 && desiredDay3) ? `${getDesiredYear(desiredMonth3)}年${desiredMonth3}月${desiredDay3}日 ${desiredHour3}` : '' }); // Third hope
  }

  if (desiredMonth2 && desiredHour2) {
    InfoCustomerBooking.splice(4, 0, { title: '第二希望', content: (desiredMonth2 && desiredHour2) ? `${getDesiredYear(desiredMonth2)}年${desiredMonth2}月${desiredDay2}日 ${desiredHour2}` : '' }); // Second hope)
  }

  const handleBackStep = (step:number) => {
    history.replace({
      search: returnHistoryPath(companyCode, step, courseCode, mediaCode, gender, serviceCode, trackingCode),
    });
  };

  const handleSubmit = async () => {
    // localhostのときはスキップ
    if (window.location.hostname === 'localhost') {
      console.log('ローカル環境のため reCAPTCHA チェックをスキップ');
    } else {
      const isChecked = await isCheckTokenCaptcha();
      if (!isChecked) {
        enqueueSnackbar('You are Robot', { variant: 'error' });
        return;
      }
    }

    try {
      setLoading(true);
      const data = formatDataInfoCustomerToSubmit({ ...context, companyCode });
      const res = await postOnlineReservationsNewCustomer(data, mediaCode, trackingCode);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: status === StatusBooking.AVAILABLE_BOOKING ? 'reservation_completed' : 'reservation_inquiry_completed',
        reservation_type: status === StatusBooking.AVAILABLE_BOOKING ? 'IMMEDIATE' : 'REQUEST',
        reservation_company_code: companyCode,
        reservation_org_id: chosenStore || '',
        reservation_org_name: chosenStoreName || res?.orgName || '',
        reservation_id: (status === StatusBooking.AVAILABLE_BOOKING ? res?.reservationId : res?.reservationInquiryId) || '',
        reservation_course: res?.contractCourseName || '',
        reservation_store: res?.orgName || '',
        reservation_status: status || '',
        ecommerce: {
          transaction_id: res?.transactionId || '',
          userTypes: '初診',
          items: [{ item_name: res?.contractCourseName || '' }],
        },
      });
      handleChangeInfoBooking && handleChangeInfoBooking({
        customerNumberBooking: res?.customerNumber || '',
        contractCourseNameBooking: res?.contractCourseName || '',
        orgNameBooking: res?.orgName || '',
        birthDateBooking: res?.birthDate || '',
        emailBooking: (status === StatusBooking.AVAILABLE_BOOKING ? res?.email : res?.mailAddress),
        customerTypeBooking: '0', // 0 is New Customer | 1 is Old Customer
        reservationIdBooking: (status === StatusBooking.AVAILABLE_BOOKING ? res?.reservationId : res?.reservationInquiryId),
        transactionIdBooking: res?.transactionId || '',
        companyCodeBooking: res?.companyCode || '',
        reservationTypeBooking: res?.reservationType || '',
      });
      history.replace({
        search: returnHistoryPath(companyCode, 5, courseCode, mediaCode, gender, serviceCode, trackingCode),
      });
    } catch (error) {
      handleError({ error, enqueueSnackbar });
    } finally {
      setLoading(false);
    }
  };

  // Begin:: ReCaptcha
  const loadScriptByURL = (id:string, url:string) => {
    const isScriptExist = document.getElementById(id);
    if (!isScriptExist) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      document.body.appendChild(script);
    }
  };

  const isCheckTokenCaptcha = useCallback(() => new Promise((resolve) => {
    window?.grecaptcha.ready(() => {
      window?.grecaptcha?.execute(CAPTCHA_SITE_KEY, { action: 'submit' }).then(async (token:string) => {
        const res = await verifyingTheUserResponseByTokenApi(token);
        const isCheckVerified:boolean = (res?.success && Number(res?.score ?? 0) >= 0.5);
        resolve(isCheckVerified);
      });
    });
  }), [CAPTCHA_SITE_KEY]);

  const removeScript = useCallback((id:string) => {
    const isScriptExist = window.document.getElementById(id);
    if (isScriptExist) {
      isScriptExist.remove();
    }
  }, []);

  const removeGReCaptchaDivElement = useCallback(() => {
    if (!window) {
      return;
    }
    const element = window.document.querySelector(
      GOOGLE_RECAPTCHA_BADGE_CLASSNAME,
    );
    if (element && element.parentElement) {
      element.parentElement.remove();
    }
  }, []);

  // End:: ReCaptcha

  const updateSize = () => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      const height = document.getElementsByTagName('body')[0]?.clientHeight || 0;
      const obj = { event: 'iframe_height', height };
      // 親へiframeの高さを送信
      // postMessage(<送信する値>, <送信先のドメイン>)
      window.parent.postMessage(obj, 'https://www.ci-z.com');
    }, 500);
  };

  useEffect(() => {
    if (!chosenStoreName || !desiredTime) {
      history.replace({
        search: stringify(courseCode ? { companyCode, courseCode } : { companyCode }),
      });
    }
    // Save history access screen
    try {
      setLoading(true);
      const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, staffId: '' };
      accessHistoryApi(paramsPost);
    } catch (error) {
      handleError({ error, enqueueSnackbar });
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (companyCode === 'ci_zlabo') {
      window.parent.postMessage({
        event: 'page_view',
        path: location?.pathname || '',
        campaign: '',
        page: 'application',
        application_number: '',
        mail: '',
      }, 'https://www.ci-z.com');
    }
    if (companyCode === 'ci_zlabo') {
      updateSize && updateSize();
      window.addEventListener('resize', updateSize);
    }
    return () => {
      window.removeEventListener('resize', updateSize);
      clearTimeout(timeOutRef.current);
    };
  }, [companyCode, location.pathname]);

  useEffect(() => {
    // load the script by passing the URL
    loadScriptByURL(SCRIPT_ID, `${GOOGLE_RECAPTCHA_V3_SCRIPT}?render=${CAPTCHA_SITE_KEY}&hl=${LANGUAGE}`);
    return () => {
      removeScript(SCRIPT_ID);
      removeGReCaptchaDivElement();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 仮予約（リクエスト予約で受け付ける）コースの場合は文言を差し替える
  let sectionHeaderTitle: string;
  if (chosenCourseAcceptRequestReservation) {
    sectionHeaderTitle = '仮予約内容確認';
  } else if (status === StatusBooking.AVAILABLE_BOOKING) {
    sectionHeaderTitle = 'ご予約内容確認';
  } else {
    sectionHeaderTitle = 'お問い合わせ内容確認';
  }

  let notiTitleContent: React.ReactNode;
  if (chosenCourseAcceptRequestReservation) {
    notiTitleContent = (
      <>
        選択されたコースは仮予約となっております。
        <br />
        店舗よりご予約確認のお電話を差し上げます。
        <br />
        お電話が繋がらない場合はキャンセルとなりますので予めご了承ください。
        <br />
        お電話は 0800 で始まる電話番号よりご連絡いたします。
      </>
    );
  } else if (status === StatusBooking.AVAILABLE_BOOKING) {
    notiTitleContent = 'お申し込み内容をご確認ください。修正する場合は「修正する」ボタンを押してください。';
  } else {
    notiTitleContent = 'ご予約を確定するものではありません。店舗スタッフより予約日時に関するご連絡をさせていただきます。';
  }

  return (
    <ScreenLoader isLoading={isLoading}>
      {/* Steps before reservation */}
      <div className={classes.root}>
        <SectionHeader title={sectionHeaderTitle} />
        <Box>
          <Typography variant="h5" className={classes.notiTitle}>
            {notiTitleContent}
          </Typography>
        </Box>
        <Box style={{ marginBottom: '2rem' }}>
          <TableDetail list={InfoSearchBooking || []} handleBackStep={() => handleBackStep(0)} />

          {
             (status === StatusBooking.CALL_BEFORE_BOOKING) && (
             <Box className={classes.boxDateAndTine}>
               <Typography className={classes.labelNotiDate}>ご希望の日時</Typography>
               <Typography className={classes.textNotiDate}>※希望の日時をお伺いするものであり、予約が確定するものではございません。</Typography>
             </Box>
             )
          }

          <TableDetail list={InfoDateBooking || []} handleBackStep={() => handleBackStep(2)} />

          <TableDetail list={InfoCustomerBooking || []} handleBackStep={() => handleBackStep(3)} />

        </Box>
        {/* Button  */}
        <div className={classes.buttonContainer}>
          <BigButtonNext content={status === StatusBooking.AVAILABLE_BOOKING ? 'お申し込みを確定' : 'お問い合わせを送信'} handleSubmit={handleSubmit} />
        </div>
      </div>
    </ScreenLoader>
  );
};

export default StepConfirmationOfReservationDetail;
